import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';

export interface IUpdateAccount {
    oldAccount: IAccount;
    updatedAccount: IAccount;
    financialStatementTemplateTypeIndex: number;
}
